import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Popover, Divider, Button, Tooltip, Row, Col } from 'antd'
import { ProjectSwitcher } from 'Components'
import { useHotKeys } from 'Hooks'
import Search from './Search'
import Feather from '@sysunite/react-feather'
import './TreeTabHeader.scss'
import TabLocker from './TabLocker'

TreeTabHeader = ({ tabs, active, setActive, disabledMap, currentProject }) ->

  [projectSwitcherVisible, setProjectSwitcherVisible] = useState(undefined)
  [title, setTitle] = useState(undefined)

  useEffect( ->
    (->
      if currentProject?
        setTitle((await Weaver.Project.load(currentProject)).name())
    )()
    undefined
  , [currentProject])

  getNextTabIndex = (curr, n) ->
    next = curr + n
    if next is -1
      next = tabs.length - 1
    else if next is tabs.length
      next = 0
    if disabledMap[tabs[next].key]
      getNextTabIndex(next, n)
    else
      next

  changeTab = (n) ->
    setActive(tabs[n].key)

  incrTab = (incr) ->
    current = tabs.findIndex(({ key }) -> key is active )
    next = getNextTabIndex(current, incr)
    changeTab(next)

  useHotKeys([{
    sequence: 'left'
    fn: -> incrTab(-1)
    watchers: [active, disabledMap]
    temporary: true
  }, {
    sequence: 'right'
    fn: -> incrTab(1)
    watchers: [active, disabledMap]
    temporary: true
  }])

  useHotKeys(
    tabs.map(({ key }) ->
      {
        fn: -> changeTab(_.findIndex(tabs, (t) -> t.key is key ))
        expr: !disabledMap[key]
        watchers: [disabledMap]
        key
      }
    ).map((conf, i) ->
      { key, rest... } = conf
      [
        { rest..., sequence: key.slice(0, 1) }, # F, M, H, E, A
        { rest..., sequence: (i + 1) + ''   }   # 1, 2, 3, 4, 5
      ]
    ).flat()
  )

  scaleFont = (l = 0) ->
    switch
      when l < 20 then 18
      when l < 25 then 16
      when l < 30 then 14
      when l < 40 then 12
      else 10

  <div className='tree-nav-header-container'>
    <Popover
      content={
        <div style={{ width: 350 }}>
          <ProjectSwitcher
            onSelectProject={ -> setProjectSwitcherVisible(false)}
          />
        </div>
      }
      overlayClassName="project-switcher-popover"
      visible={projectSwitcherVisible}
      onVisibleChange={(visible) -> setProjectSwitcherVisible(visible)}
      placement="bottom"
      trigger="click"
    >
      <h2 className='project-title' style={{ fontSize: scaleFont(title?.length), lineHeight: '24px' }}>
        { title || 'No space' }
        { <Feather className="title-chevron" size="0.9em" type="chevron-down" style={{ opacity: 1 }} /> }
      </h2>
    </Popover>
    <Divider className='tree-nav-header-divider' />
    <Row>
      <Col style={{ zIndex: 2 }}>
        <TabLocker />
      </Col>
      <Col flex={1}>
        <div className='tree-tab-nav-icon-container'>
          {tabs.map(({ key, icon }) ->
            disabled = disabledMap[key]
            <span
              key={key}
            >
              <Tooltip mouseEnterDelay={0.5} placement="bottom" title={_.startCase(key)}>
                <a>
                  <Button
                    className="tree-tab-nav-icon #{ 'active' if key is active }"
                    data-testid="tab-#{key}"
                    type="link"
                    onClick={-> setActive(key) unless disabled}
                    style={{
                      color: if key isnt active then '#242c31'
                      opacity: if disabled then 0.5
                      cursor: if disabled then 'default' else 'pointer'
                    }}
                    icon={<Feather style={{ height: '100%' }} type={icon} size={18} />}
                  />
                </a>
              </Tooltip>
            </span>
          )}
        </div>
      </Col>
      <Col>
        <Tooltip
          placement="bottom"
          title="Global Search"
          mouseEnterDelay={0.5}
        >
          <a>
            <Search />
          </a>
        </Tooltip>
      </Col>
    </Row>
  </div>

mapStateToProps = ({ projects: { currentProject } }) -> { currentProject }

export default connect(mapStateToProps)(TreeTabHeader)
